import { useState, useEffect } from 'react';
import { FaFacebookF, FaTwitter, FaInstagram, FaYoutube, FaTiktok, FaTumblr, FaDiscord, FaUserTie } from 'react-icons/fa';
import { HiLocationMarker } from 'react-icons/hi';
import UserAppContext from '../../hook/UserAppContext';
import Friend from '../friend/Friend';
import './main.css';

const Main = ({isSetPage}) => {

      const {user, data} = UserAppContext()
      const [menu, setMenu] = useState(false);
      const [online, setOnline] = useState([]);
      const [friend, setFriend] = useState(false);
      const {banners, social, galleries, friends, infordata, relation, videos} = user.user;
      const id_user = infordata.data || infordata.id_xat === '' ? 0 : infordata.id_xat;

      async function getOnline(id){

            try{
                  const response = await fetch(`https://oceanbot.net/online.php?id=${id}`);
                  const result = await response.json();
                  setOnline(result);
            }
            catch(err){
                  console.log('Error: ', err);
            }
      }

      useEffect(() => {
            getOnline(id_user);
      }, [id_user]);

      const showMenu = () => {
            if(!menu){
                  setMenu(true);
            }
            else{
                  setMenu(false);
            }
      }

      const showGallery = () => {
            isSetPage(true);
      }

      const showFriend = () => {
            setFriend(true);
      }

      const name = infordata.data || infordata.name === '' ? data.info.name : infordata.name
      const avatar = infordata.data || infordata.avatar === '' ? data.info.avatar : infordata.avatar
      const status = infordata.data || infordata.status === '' ? data.info.status : infordata.status 
      const about = infordata.data || infordata.about === '' ? data.info.about : infordata.about 
      const location = infordata.data || infordata.location === '' ? data.info.location : infordata.location
      const id_xat = infordata.data || infordata.id_xat === '' ? data.info.id_xat : infordata.id_xat

      return (
            <div className="main_content">
                  <div className="main_header">
                        <div className="main_header__banner">
                              <div className="banner_img">
                                    <img src={banners.data ? data.banner.image : banners[0].image} alt={banners.data ? data.banner.title : banners[0].title} />
                              </div>
                              <div className="banner_title">
                                    <span>Personal Page</span>
                                    <h1>{banners.data ? data.banner.title : banners[0].title}</h1>
                              </div>
                        </div>
                        <div className="main_header__social_nav">
                              <div className="social_nav__menu">
                                    <a href={(social.facebook !== '') ? social.facebook : "https://wwew.facebook.com"}><FaFacebookF /></a>
                                    <a href={(social.twitter !== '') ? social.twitter : "https://wwew.twitter.com"}><FaTwitter /></a>
                                    <a href={(social.instagram !== '') ? social.instagram : "https://wwew.instagram.com"}><FaInstagram /></a>
                                    <a href={(social.youtube !== '') ? social.youtube : "https://wwew.youtube.com"}><FaYoutube /></a>
                                    <a href={(social.tiktok !== '') ? social.tiktok : "https://wwew.tiktok.com"}><FaTiktok /></a>
                                    <a href={(social.tumblr !== '') ? social.tumblr : "https://wwew.tumblr.com"}><FaTumblr /></a>
                                    <a href={(social.discord !== '') ? social.discord : "https://wwew.discord.com"}><FaDiscord /></a>
                              </div>
                              <div className="social_nav__title">
                                    <span>Social media</span>
                              </div>
                        </div>
                        <div className={(menu) ? "main_header__icon_menu active" : "main_header__icon_menu"} onClick={() => showMenu()}>
                              <div className="bar_menu"></div>
                              <div className="bar_menu"></div>
                              <div className="bar_menu"></div>
                        </div>
                        <div className={(menu) ? "main_header__drop_menu show" : "main_header__drop_menu"}>
                              <div className="main_header__drop_menu__inner">
                                    <button className="menu_btn" onClick={() => showGallery()}>
                                          <span>Gallery</span><sup>{galleries.data ? 0 : galleries.length}</sup>
                                    </button>
                                    <button className="menu_btn" onClick={() => showFriend()}>
                                          <span>Friends</span><sup>{friends.data ? 0 : friends.length}</sup>
                                    </button>
                              </div>
                              
                        </div>
                  </div>

                  <div className="container">
                        <div className="container_col">
                              <div className="wrapper_user">
                                    <div className="user_header">
                                          <div className="user_header__banner">
                                                <img src={avatar} alt={name} />
                                          </div>
                                          <div className="user_online">
                                                <div className="user_online__icon">
                                                      <FaUserTie />
                                                      <div className={(online.status === 'online') ? "user_online__dots green" : "user_online__dots red"}></div>
                                                </div>
                                                <span>{(online.status === 'online') ? "Online Now" : "Offline"}</span>
                                          </div>
                                    </div>
                                    <div className="user_main">
                                          <div className="user_main__data">
                                                <div className="user_data__avatar">
                                                      <img src={avatar} alt={name} />
                                                </div>
                                                <div className="user_data__info">
                                                      <h3>{id_xat}</h3>
                                                      <h2>@{name}</h2>
                                                      <p>{status}</p>
                                                </div>
                                          </div>
                                          {
                                                (!relation.data) 
                                                      ? <div className="user_main__relation">
                                                            <div className="relation_type">
                                                                  <span>{relation.relation_type}</span>
                                                                  <div className="relation_data">
                                                                        <h2>{relation.name === '' ? data.relation.name : relation.name}</h2>
                                                                        <a href={relation.me === '' ? data.relation.me : relation.me} target="_blank" rel="noreferrer">xat.me</a>
                                                                  </div>
                                                                  <div className="relation_avatar">
                                                                        <img src={relation.avatar === '' ? data.relation.avatar : relation.avatar} alt={relation.name === '' ? data.relation.name : relation.name} />
                                                                  </div>
                                                            </div>
                                                        </div>
                                                      : ''
                                          }
                                          <div className="user_main__location">
                                                <HiLocationMarker />
                                                <span>{location}</span>
                                          </div>
                                    </div>
                              </div>
                        </div>
                        <div className="container_col">
                              <div className="user_about">
                                    <p>{about}</p>
                              </div>
                              {
                                    (!videos.data) 
                                          ? <div className="wrapper_video">
                                                <div className="video_box">
                                                <iframe width="100%" height="100%" src={`https://www.youtube.com/embed/${videos[0].id_video}`} title="YouTube video player" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"></iframe>
                                                </div>
                                            </div>
                                          : ''
                              }
                        </div>
                  </div>
                  <Friend friends={friends} isFriend={friend} isSetFriend={setFriend} />
                  <div className="footer">
                        <p>&copy; 2023 - xatme.com - JasonOficial - 1202</p>
                  </div>
            </div>
      )
}

export default Main;